<div class="menu-div">
  <h4 class="header">Web QR Code</h4>
  <mat-divider></mat-divider>
  <div class="container">
    <div class="card">
      <h2>Web QR Code</h2>
      <!--     
        <div class="url-display">
          <input [(ngModel)]="url" class="url-input" placeholder="Enter your URL" />
          <button (click)="generateQRCode()" class="generate-btn">Generate</button>
        </div>
    
        <div class="qr-code-container">
          <canvas id="qrCodeCanvas"></canvas>
        </div>
     -->
      <!-- URL Section -->
      <div class="url-display">
        <input [value]="url" readonly class="url-input" />
      </div>

      <!-- QR Code Section -->
      <div class="qr-code-container">
        <canvas id="qrCodeCanvas"></canvas>
        <!-- <img [src]="qrCode" alt="QR Code" /> -->
      </div>

      <!-- Scan Count Section -->
      <div class="scan-count">
        <p>Total Scans: {{ scanCounts }}</p>
      </div>
      <!-- Actions -->
      <div class="actions">
        <button (click)="copyUrl()" class="copy-btn">Copy URL</button>
        <button (click)="downloadQrCode()" class="download-btn">Download QR Code</button>
      </div>
    </div>
  </div>

</div>